import React from "react";
import ReactDOM from "react-dom/client";
import "./style/style.scss";
import App from "./App";

const rootElement = document.getElementById("root") as HTMLElement;
rootElement.className = "wrapper";

const root = ReactDOM.createRoot(rootElement);

root.render(<App />);
